// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"ada087fb","839":"9c561b97"}[chunkId] + ".chunk.js";
};